export type Theme = "dark" | "light";

export const THEME_STORAGE_KEY = "portfolio-theme";

export const getStoredTheme = (): Theme | null => {
  const stored = localStorage.getItem(THEME_STORAGE_KEY);
  if (stored === "light" || stored === "dark") return stored;
  return null;
};

export const getInitialTheme = (): Theme => getStoredTheme() ?? "dark";

export const applyTheme = (theme: Theme) => {
  document.documentElement.setAttribute("data-theme", theme);
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) {
    meta.setAttribute("content", theme === "light" ? "#ffffff" : "#09090b");
  }
};

applyTheme(getInitialTheme());
